import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';
import { scrollTo } from '../utils/scrollTo';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t, lang, switchLang } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const trackContact = (actionName) => {
    if (window.fbq) {
      window.fbq('track', 'Contact', {
        language: lang,
        action: actionName
      });
    }
  };

  const navLinks = [
    { name: t.nav.home, id: 'home' },
    { name: t.nav.features, id: 'features' },
    { name: t.nav.gallery, id: 'gallery' },
    { name: t.nav.amenities, id: 'amenities' },
    { name: t.nav.contact, id: 'contact' },
  ];

  const handleNavClick = (e, id) => {
    e.preventDefault();
    scrollTo(id);
    setMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-white py-5'}`}>
      <div className="container-custom flex justify-between items-center">
        <div className="flex-shrink-0">
          <a href="#" onClick={(e) => handleNavClick(e, 'home')} className="text-xl font-semibold text-slate-900 tracking-tight">
            {t.footer.title}
          </a>
        </div>
        
        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={`#${link.id}`} 
              onClick={(e) => handleNavClick(e, link.id)}
              className="text-sm font-medium text-slate-600 hover:text-brand transition-colors"
            >
              {link.name}
            </a>
          ))}
          
          <div className="flex items-center space-x-2 text-sm font-medium border-l border-slate-200 pl-6">
            <button
              onClick={() => switchLang('en')}
              className={`transition-colors ${lang === 'en' ? 'text-brand font-bold' : 'text-slate-500 hover:text-slate-700'}`}
            >
              English
            </button>
            <span className="text-slate-300">|</span>
            <button
              onClick={() => switchLang('es')}
              className={`transition-colors ${lang === 'es' ? 'text-brand font-bold' : 'text-slate-500 hover:text-slate-700'}`}
            >
              Español
            </button>
          </div>

          <a 
            href="#contact" 
            onClick={(e) => { 
              trackContact('Schedule a Tour');
              handleNavClick(e, 'contact'); 
            }} 
            className="btn-primary py-2 px-5 text-sm"
          >
            {t.nav.schedule}
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center space-x-4">
          <div className="flex items-center space-x-2 text-sm font-medium">
            <button onClick={() => switchLang('en')} className={`${lang === 'en' ? 'text-brand font-bold' : 'text-slate-500'}`}>EN</button>
            <span className="text-slate-300">|</span>
            <button onClick={() => switchLang('es')} className={`${lang === 'es' ? 'text-brand font-bold' : 'text-slate-500'}`}>ES</button>
          </div>
          <button className="p-2 text-slate-600 focus:outline-none" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <SafeIcon name={mobileMenuOpen ? "X" : "Menu"} className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg border-t border-slate-100">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={`#${link.id}`} 
                className="block text-base font-medium text-slate-700 hover:text-brand" 
                onClick={(e) => handleNavClick(e, link.id)}
              >
                {link.name}
              </a>
            ))}
            <div className="pt-4 mt-2 border-t border-slate-100">
              <a 
                href="#contact" 
                className="btn-primary w-full justify-center" 
                onClick={(e) => {
                  trackContact('Schedule a Tour');
                  handleNavClick(e, 'contact');
                }}
              >
                {t.nav.schedule}
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;